import { createTheme } from '@mui/material';

export const labelColors = {
  positive: {
    main: 'rgba(76, 175, 80, 0.15)',
    hover: 'rgba(76, 175, 80, 0.25)',
    border: 'rgba(76, 175, 80, 0.5)',
    chip: 'success',
  },
  negative: {
    main: 'rgba(244, 67, 54, 0.15)',
    hover: 'rgba(244, 67, 54, 0.25)',
    border: 'rgba(244, 67, 54, 0.5)',
    chip: 'error',
  },
  uncertain: {
    main: 'rgba(255, 193, 7, 0.15)',
    hover: 'rgba(255, 193, 7, 0.25)',
    border: 'rgba(255, 193, 7, 0.5)',
    chip: 'warning',
  },
  both: {
    main: 'rgba(156, 39, 176, 0.15)',
    hover: 'rgba(156, 39, 176, 0.25)',
    border: 'rgba(156, 39, 176, 0.5)',
    chip: 'purple',
  },
  unidentifiable: {
    main: 'rgba(255, 98, 7, 0.8)',
    hover: 'rgba(255, 98, 7, 0.08)',
    border: 'rgba(255, 98, 7, 0.8)',
    chip: 'default',
  },
  'no attempt': {
    main: 'rgba(97, 97, 97, 0.35)',
    hover: 'rgba(97, 97, 97, 0.45)',
    border: 'rgba(66, 66, 66, 0.85)',
    chip: 'default',
  },
};

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});
